import styled from 'styled-components';
// import media from '../../../../styles/media.style';

export const Container = styled.div`
  position: relative;
`;

export const Canvas = styled.canvas`
  position: relative;
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/CareMenuImage/CareMenuImage.style.js